import React, {useEffect} from 'react';
import Script from 'next/script';
import {Router} from 'next/router';

import {SITE_URL} from '../../lib/seo/site';
import {useCookieConsent} from '../cookie-consent';
import {METRIKA_ID} from './metrika-id';

declare global {
	interface Window {
		ym?: (id: number, action: string, ...args: unknown[]) => void;
	}
}

/** Метрика считает только прод: локальная прод-сборка (next start) тоже собрана с NODE_ENV=production */
const SITE_HOST = new URL(SITE_URL).hostname;

/** Код счётчика из кабинета Метрики: сначала очередь вызовов, затем загрузка tag.js */
const COUNTER = `if (location.hostname === '${SITE_HOST}') {
(function(m,e,t,r,i,k,a){
	m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
	m[i].l=1*new Date();
	for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
	k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
})(window, document,'script','https://mc.yandex.ru/metrika/tag.js', 'ym');

ym(${METRIKA_ID}, 'init', {webvisor:true, clickmap:true, referrer: document.referrer, url: location.href, accurateTrackBounce:true, trackLinks:true});
}`;

/**
 * Яндекс.Метрика. Счётчик грузится после согласия на cookie и после гидрации, поэтому не задерживает первую отрисовку.
 * Переходы внутри сайта не перезагружают страницу, и просмотр приходится отправлять самим.
 */
export const Metrika: React.FC = () => {
	const {consent} = useCookieConsent();
	useEffect(() => {
		const handleRouteChange = (url: string) => {
			window.ym?.(METRIKA_ID, 'hit', url, {title: document.title, referer: document.referrer});
		};
		Router.events.on('routeChangeComplete', handleRouteChange);
		return () => Router.events.off('routeChangeComplete', handleRouteChange);
	}, []);

	// в разработке счётчик не нужен: он считал бы локальные заходы как посещения сайта
	if (process.env.NODE_ENV !== 'production') return null;

	// счётчик ставит cookie, поэтому грузится только после согласия посетителя
	if (consent !== 'accepted') return null;

	return <Script id="yandex-metrika" strategy="afterInteractive" dangerouslySetInnerHTML={{__html: COUNTER}} />;
};
